import axiosTemp from '../../../../api/axiosTemp'
import type {
  TimesheetValidationPayload,
  TimesheetValidationResponse,
} from '../types'

export async function validateTimesheets(
  payload: TimesheetValidationPayload
): Promise<TimesheetValidationResponse> {
  const response = await axiosTemp().post(
    '/api/v1.0/accounts/ACCOUNT_ID/ocg/validate/timesheets/',
    JSON.stringify(payload)
  )

  return response.data
}
